export function reloadOnceOnly() {
  // SSR guard
  if (typeof window === 'undefined') return;
  try {
    const KEY = 'session_reloaded';
    if (window.sessionStorage.getItem(KEY) === 'true') return;
    window.sessionStorage.setItem(KEY, 'true');
  } catch {}
  window.location.reload();
}
